(() => {
  const GIFT_CONTAINER_SELECTOR = '.sns-gift-new-cart-container';
  const ERROR_ID = 'GiftCheckoutValidationError';
  const ERROR_MESSAGE = 'ギフト配送をご希望の場合は、手提げ袋を選択してください。';

  const normalize = (value) => (value || '').replace(/[\s\u00a0：:]/g, '');

  function isGiftDeliverySelected(drawer) {
    const container = drawer.querySelector(GIFT_CONTAINER_SELECTOR);
    if (!container) return false;

    const labelledControls = container.querySelectorAll('label, [role="checkbox"]');
    return Array.from(labelledControls).some((element) => {
      if (!normalize(element.textContent).includes('ギフト配送を希望する')) return false;

      const input = element.matches('input') ? element : element.querySelector('input[type="checkbox"]');
      return Boolean(
        (input && input.checked) ||
          element.getAttribute('aria-checked') === 'true' ||
          element.matches('[data-checked]') ||
          element.querySelector('[data-checked]')
      );
    });
  }

  function hasRequiredShoppingBag(drawer) {
    if (drawer.querySelector('[data-shopping-bag-required="true"]')) return true;

    const giftContainer = drawer.querySelector(GIFT_CONTAINER_SELECTOR);
    if (!giftContainer) return false;

    // The selected value is the bag name (for example,
    // "リボン付きショッパー"), rather than the literal value "要".
    return Array.from(giftContainer.querySelectorAll('button, div, li, label')).some((element) => {
      const text = normalize(element.textContent);
      if (!text.startsWith('手提げ袋')) return false;

      const selectedValue = text.slice('手提げ袋'.length);
      return selectedValue !== '' && !selectedValue.startsWith('不要');
    });
  }

  function removeError(drawer) {
    drawer.querySelector(`#${ERROR_ID}`)?.remove();
  }

  function showError(drawer) {
    let error = drawer.querySelector(`#${ERROR_ID}`);
    if (!error) {
      error = document.createElement('p');
      error.id = ERROR_ID;
      error.setAttribute('role', 'alert');
      error.style.cssText = 'width:100%;margin:8px 0 0;color:#b42318;font-size:14px;line-height:1.6;';
      error.textContent = ERROR_MESSAGE;

      const giftContainer = drawer.querySelector(GIFT_CONTAINER_SELECTOR);
      const checkoutButton = findThemeCheckoutButton(drawer);
      if (giftContainer) giftContainer.insertAdjacentElement('afterend', error);
      else if (checkoutButton) checkoutButton.insertAdjacentElement('beforebegin', error);
    }

    error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    error.focus?.({ preventScroll: true });
  }

  function findThemeCheckoutButton(drawer) {
    return drawer.querySelector('button[name="checkout"], a[href*="/checkout"]');
  }

  function isCheckoutControl(element, drawer) {
    const control = element.closest('button, a, input[type="submit"]');
    if (!control || !drawer.contains(control)) return false;
    if (control.matches('[name="checkout"], a[href*="/checkout"]')) return true;

    const text = normalize(control.textContent || control.value);
    return text === 'チェックアウト' || text === '購入手続きへ';
  }

  function shouldBlock(drawer) {
    const giftSelected = isGiftDeliverySelected(drawer);
    const shoppingBagSelected = hasRequiredShoppingBag(drawer);
    if (!giftSelected || shoppingBagSelected) removeError(drawer);
    return giftSelected && !shoppingBagSelected;
  }

  document.addEventListener(
    'click',
    (event) => {
      const drawer = event.target.closest('cart-drawer');
      if (!drawer || !isCheckoutControl(event.target, drawer) || !shouldBlock(drawer)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showError(drawer);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const drawer = event.target.closest('cart-drawer');
      const submitter = event.submitter;
      if (!drawer || !submitter || !isCheckoutControl(submitter, drawer) || !shouldBlock(drawer)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showError(drawer);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const drawer = event.target.closest('cart-drawer');
    if (drawer) shouldBlock(drawer);
  });
})();
